import { useEffect, useState } from "react";
import { loadMarketing } from "@/lib/marketing";

export function AdFrame({ code, width, height, testId, fit = true }) {
  const doc = `<!doctype html><html><head><style>html,body{margin:0;height:100%;width:100%;background:transparent}body{display:flex;align-items:center;justify-content:center;overflow:hidden}</style></head><body>${code}</body></html>`;
  return (
    <iframe data-testid={testId} title="Sponsored" srcDoc={doc} width={width} height={height}
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
      className={`${fit ? "max-w-full" : "max-w-none"} border-0 rounded-xl bg-black/20`} />
  );
}

export function AdSlot({ className = "" }) {
  const [code, setCode] = useState("");
  useEffect(() => { loadMarketing().then((c) => setCode(c.banner_code || "")); }, []);
  if (!code) return null;
  return (
    <div data-testid="ad-slot" className={`flex flex-col items-center gap-1 ${className}`}>
      <span className="text-[9px] uppercase tracking-[0.3em] text-text-muted">Sponsored</span>
      <div className="hidden md:block"><AdFrame code={code} width={728} height={90} testId="ad-slot-desktop" /></div>
      <div className="md:hidden"><AdFrame code={code} width={320} height={100} testId="ad-slot-mobile" /></div>
    </div>
  );
}
